<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title></v-card-title>
                <div class="d-flex">
                    <v-btn color="default" dark @click="redirectByUrl('/admin/ads/categories/')">Categories d'annonces</v-btn>
                </div>  
                <div class="row">
                    <h6 class="col-12">{{$t('intram_ads.ads_title')}}</h6>
                    <div class="col-lg-4 col-12">
                        <v-text-field v-model="search" append-icon="mdi-magnify" solo label="Search" single-line hide-details></v-text-field>
                    </div>
                    <div class="col-lg-8 col-12 text-right">
                        <v-btn color="default" dark class="mb-2" @click="dialog=true">{{$t('intram_ads.add_ad')}}</v-btn>
                        <v-btn color="default" dark class="ml-4 mb-2" @click="batchDialog=true">Ajouter en lot</v-btn>
                    </div>  
                </div>
                <v-data-table no-headers
                    :headers="headers"
                    :items="ads_datas"
                    :search="search"
                    :loading="ads_datas===undefined" loading-text="Chargement en cours..."
                    sort-by="label"
                    class="elevation-0 mt-0 pt-0">
                    <template v-slot:item.cover="{item}">
                        <a :href="image_base_link+item.cover" target="_blank">
                            <v-img
                                :src="image_base_link+item.cover"
                                :lazy-src="image_base_link+item.cover"
                                max-width="40"
                                max-height="40">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </a>
                    </template>
                    <template v-slot:item.description="{item}">
                        {{ limiText(item.description,50) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div style="text-align: right">
                            <v-menu key="text" rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">
                                    <v-icon class="black--text" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item @click="redirectByUrl('/admin/ads/'+item._id)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-cogs</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Détails</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="description(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-eye</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Description</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="editItem(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-pencil</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Modifier</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="confimDeleteAds(item)">
                                        <v-list-item-icon>
                                            <v-icon color="red">mdi-trash-can-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Supprimer</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
                <div class="col-12 text-right" style="background: #f8f8f8">
                    <v-pagination
                        elevation="0"
                        v-model="page"
                        :length="total_pages"
                        :total-visible="7"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right"
                        @input="getAllAds">
                    </v-pagination>
                </div>
                <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
                    <v-card>
                        <v-card-text>
                            <v-text-field v-if="submitting" color="primary" loading disabled></v-text-field>
                            <v-alert v-if="errors.operation" dense outlined type="error">
                                {{errors.operation}}
                            </v-alert>
                            <v-form ref="form" v-model="valid" :lazy-validation="lazy" enctype="multipart/form-data">
                                <v-row>
                                    <v-col cols="12" sm="12" class="mt-5">
                                        <h3>Ajouter une nouvelle annonce</h3>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <label>Images de l'annonce <br> <small v-if="id">Ne cliquez que si vous souhaitez mettre à jour le logo du service</small></label>
                                        <v-file-input v-model="files" accept="image/png, image/jpeg" ref="files" :rules="fileRules" solo placeholder="Téléversez les images de l'annuaire" label="Téléversez les images de l'annonce" prepend-icon="mdi-paperclip" multiple>
                                            <template v-slot:selection="{ text }">
                                                <v-chip small label color="primary">{{ text }}</v-chip>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <label>Nom de l'annonce</label>
                                        <v-text-field solo :rules="inputRules" v-model="editedItem.name" :label="$t('name')"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <label>Catégorie</label>
                                        <v-autocomplete :rules="inputRules" v-model="editedItem.category" item-text="name" item-value="_id" :items="adsCategories" solo chips small-chips label="Catégorie"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <label>Description</label>
                                        <v-textarea solo :rules="descriptionRules" v-model="editedItem.description" name="input-7-4" rows="2" :label="$t('description')"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="dark" @click.prevent="close">{{$t('cancel')}}</v-btn>
                            <v-btn color="primary" :loading="submitting" :disabled="!valid || mis" @click.prevent="save">{{id ? $t("update") : $t('save')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="batchDialog" max-width="500px" @click:outside="closeBatchDialog">
                    <v-card>
                        <v-stepper v-model="step">
                            <v-stepper-header>
                                <v-stepper-step :complete="step > 1" step="1">Choisir la catégorie</v-stepper-step>
                                <v-stepper-step :complete="step > 2" step="2">Téléverser le fichier Excel</v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-card-text>
                                        <v-form ref="batchForm" v-model="batchValid" :lazy-validation="lazy">
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <label>Catégorie</label>
                                                    <v-autocomplete :rules="inputRules" v-model="batchCategory" item-text="name" item-value="_id" :items="adsCategories" solo chips small-chips label="Catégorie"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12">
                                                    <v-btn color="primary" :disabled="batchCategory === ''" @click="downloadTemplate">Télécharger le fichier modèle</v-btn>
                                                </v-col>
                                                <v-col cols="12" sm="12">
                                                    <p>Veuillez télécharger le fichier modèle correspondant à la catégorie sélectionnée et le remplir avant de le téléverser.</p>
                                                </v-col>
                                                <v-col cols="12" sm="12">
                                                    <v-radio-group v-model="hasDownloadedTemplate" :rules="[v => !!v || 'Vous devez attester que vous avez téléchargé le fichier modèle']">
                                                        <v-radio label="J'atteste avoir téléchargé le fichier modèle" value="yes"></v-radio>
                                                    </v-radio-group>
                                                </v-col>
                                                
                                            </v-row>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark" @click.prevent="closeBatchDialog">Annuler</v-btn>
                                        <v-btn color="primary" @click="step = 2" :disabled="!batchValid || !hasDownloadedTemplate">Suivant</v-btn>
                                    </v-card-actions>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                    <v-card-text>
                                        <p>Veuillez vous assurer que le fichier que vous allez téléverser suit bien le modèle téléchargé à l'étape précédente et que vous avez correctement rempli le fichier modèle.</p>
                                        <v-file-input v-model="batchFile" accept=".xlsx, .xls" ref="batchFile" :rules="fileRules" solo placeholder="Téléversez le fichier Excel" label="Téléversez le fichier Excel" prepend-icon="mdi-paperclip">
                                            <template v-slot:selection="{ text }">
                                                <v-chip small label color="primary">{{ text }}</v-chip>
                                            </template>
                                        </v-file-input>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark" @click="step = 1">Précédent</v-btn>
                                        <v-btn color="primary" :loading="submitting" :disabled="!batchFile" @click.prevent="uploadBatch">Téléverser</v-btn>
                                    </v-card-actions>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-card>
                </v-dialog>
            </v-card>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../../mixins/helpers";
    import {client} from "../../../store/services/client";
    import {env} from "../../../../env";
    export default {
        name: "ads",
        mixins: [helpers(this)],
        data() {
            return {
                page: 0,
                total_pages: 0,
                submitting: false,
                valid: true,
                lazy: false,
                mis: false,
                errors: {},
                files: [],
                search: '',
                dialog: '',
                batchDialog: false,
                step: 1,
                batchValid: false,
                batchCategory: '',
                batchFile: null,
                hasDownloadedTemplate: '',
                ads_datas: undefined,
                adsCategories: undefined,
                ad_status: false,
                image_base_link: env.image_base_url,
                customSnack: {
                    snackbar: false,
                    text: "",
                    snackcolor: "black",
                    snackbBtnColor: "white",
                    snacktimeout: 2000
                },
                id: undefined,
                headers: [
                    { text: this.$t('cover'), value: 'cover' },
                    { text: this.$t('name'), align: 'start', sortable: false, value: 'name' },
                    { text: this.$t('categorie'), value: 'category.name' },
                    { text: this.$t('description'), value: 'description' },
                    { text: this.$t('date'), value: '_created_at' },
                    { text: '', value: 'actions', sortable: false }
                ],
                editedIndex: -1,
                editedItem: {
                    name: '',
                    images: '',
                    description: '',
                    category: true
                },
                defaultItem: {
                    name: '',
                    images: '',
                    description: '',
                    category: '',
                    _id: ''
                },
                labelRules: [
                    v => !!v || this.$t('name_required')
                ],
                inputRules: [
                    v => !!v || this.$t('value_required')
                ],
                descriptionRules: [
                    v => !!v || this.$t('description_required')
                ],
                fileRules: [
                    v => !!v || this.$t('file_required')
                ]
            }
        },
        computed: {
            ...mapState('auth/', ['countries'])
        },
        mounted() {
            this.$store.dispatch('auth/getCountries');
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            batchDialog(val) {
                if (!val) {
                    this.step = 1;
                    this.batchCategory = '';
                    this.batchFile = null;
                    this.hasDownloadedTemplate = '';
                }
            }
        },
        methods: {
            initialize() {
                this.getAllAdsCategories();
                this.getAllAds();
            },
            editItem(item) {
                this.editedItem = item;
                this.dialog = true;
                this.id = item._id;
            },
            description(item) {
                Swal.fire({
                    title: this.$t('description'),
                    timerProgressBar: false,
                    text: item.description,
                    confirmButtonText: "Fermer",
                    confirmButtonColor: '#29B3A6'
                });
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
                this.$refs.form.reset();
            },
            closeBatchDialog() {
                this.batchDialog = false;
                this.$nextTick(() => {
                    this.step = 1;
                    this.batchCategory = '';
                    this.batchFile = null;
                    this.hasDownloadedTemplate = '';
                });
            },
            async confimDeleteAds(item) {
                this.confirm_toast(
                    'warning',
                    'Suppression',
                    "Êtes vous sûr de vouloir éffectuer cette action ?",
                    'Oui, supprimer',
                    "Non",
                    await this.deleteAds(item)
                );
            },
            async deleteAds(item) {
                this.ad_status = true;
                const response = await client({
                    method: 'post',
                    url: `/ads/delete`,
                    data: { id: item._id }
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error);
                        this.ad_status = false;
                        return { error: true };
                    });
                this.ad_status = false;
                if (response && !response.error) this.getAllAds();
            },
            async getAllAds(page = 1) {
                this.ad_status = true;
                page = page - 1;
                const response = await client({
                    method: 'get',
                    url: `/ads`,
                    data: { page: page }
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error);
                        this.ad_status = false;
                        return { error: true };
                    });
                this.ad_status = false;
                if (response && !response.error) {
                    this.ads_datas = response.ads.map(ad => ({ ...ad, cover: ad.images[0] }));
                    this.page = response.page + 1;
                    this.total_pages = response.total_pages;
                }
            },
            async getAllAdsCategories(page = 1) {
                page = page - 1;
                const response = await client({
                    method: 'get',
                    url: `/ads/categories`,
                    data: { page: page }
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error);
                        return { error: true };
                    });
                if (response && !response.error) {
                    this.adsCategories = response.ads;
                    this.page = response.page + 1;
                    this.total_pages = response.total_pages;
                }
            },
            async save() {
                let data = new FormData();
                this.files.forEach((image) => {
                    data.append("images", image);
                });
                data.append("name", this.editedItem.name);
                data.append("description", this.editedItem.description);
                data.append("category", this.editedItem.category);
                let url = '/ads/';
                if (this.id) {
                    data.append("_id", this.id);
                }
                this.submitting = true;
                const response = await client({
                    method: 'post',
                    url: url,
                    data: data
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error);
                        this.submitting = false;
                        return { error: true };
                    });
                this.submitting = false;
                if (response && !response.error) {
                    this.toast('success', this.$t(response.message));
                    this.reset();
                    this.dialog = false;
                    this.id = undefined;
                    this.getAllAds();
                }else {
                    this.toast('error',this.$t(response.message))
                    this.reset()
                    this.dialog=false
                    this.id = undefined
                    }
            },
            async uploadBatch() {
                let data = new FormData();
                data.append("file", this.batchFile);
                this.submitting = true;
                const response = await client({
                    method: 'post',
                    url: `/ads/batch/upload-excel/${this.batchCategory}`,
                    data: data
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error);
                        this.submitting = false;
                        return { error: true };
                    });
                this.submitting = false;
                if (response && !response.error) {
                    this.toast('success', this.$t(response.message));
                    this.batchDialog = false;
                    this.getAllAds();
                }
            },
            validate() {
                this.$refs.form.validate();
            },
            reset() {
                this.$refs.form.reset();
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1);
            },
            async downloadTemplate() {
                const category = this.batchCategory;
                const categoryName = this.adsCategories.find(c => c._id === category).name;
                console.log(category)
                console.log(categoryName)
                
                const response = await client({
                    method: 'get',
                    url: `/ads/batch/download-excel/${category}`,
                    headers: {
                        'Content-Type': 'blob',

                    },
                    responseType: 'arraybuffer'
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error);
                        return { error: true };
                    });
                // if (response && !response.error) {
                    const url = URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${categoryName}_template.xlsx`);
                    document.body.appendChild(link);
                    link.click()
                // }
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize();
        }
    }
</script>

<style scoped>
</style>
